import { IRootState } from '@/store'
import { ActionTree, MutationTree } from 'vuex'
import { CommonActionType } from './action-type'
import { AugmentedCommonActionType } from './ICommonActions'
import { ICommonMutations } from './ICommonMutations'
import { CommonMutationType } from './mutation-type'
import {
  getOrderStatusAPI
} from './services/common.api'
export interface ICommonState {
  orderStatusList: object,
}

const state = (): ICommonState => ({
  orderStatusList: {}
})

const getters = {
  getOrderStatus (state: ICommonState) {
    return state.orderStatusList
  }
}

const actions: ActionTree<ICommonState, IRootState> = {
  async [CommonActionType.FETCH_ORDER_STATUS_LIST] ({ commit }: AugmentedCommonActionType) {
    try {
      const data = await getOrderStatusAPI()
      commit(CommonMutationType.SET_ORDER_STATUS_LIST, data)
    } catch (error) {
      console.error(error)
    }
  }
}

const mutations: MutationTree<ICommonState> & ICommonMutations = {
  [CommonMutationType.SET_ORDER_STATUS_LIST] (state, payload) {
    state.orderStatusList = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
